import jwtDecode from 'jwt-decode';

export default {
  state: {
    notifications: [],
    modalData: {
      modalState: '',
      modalSize: '',
      modalItem: [],
      modalIsActive: false,
      modalCurrentVin: {},
      modalCurrentStatus: '',
      modalSearchValue: '',
      modalCurrentNewItem: '',
      modalCurrentNewAvailability: '',
      modalCurrentNewModel: '',
    },
    token: localStorage.getItem('token'),
  },
  getters: {
    getModalData: (state) => state.modalData,
    // * Notifications
    getNotifications: (state) => state.notifications,
  },
  mutations: {
    setCloseModal(state) {
      state.modalData.modalState = '';
      state.modalData.modalIsActive = false;
    },
    setCurrentVin(state, payload) {
      state.modalData.modalCurrentVin = payload;
    },
    setCurrentStatus(state, payload) {
      state.modalData.modalCurrentStatus = payload;
    },
    setCurrentSearch(state, payload) {
      state.modalData.modalSearchValue = payload;
    },
    setCurrentNewItem(state, payload) {
      state.modalData.modalCurrentNewItem = payload;
    },
    setCurrentNewAvailability(state, payload) {
      state.modalData.modalCurrentNewAvailability = payload;
    },
    setCurrentNewModel(state, payload) {
      state.modalData.modalCurrentNewModel = payload;
    },
    async setOpenModal(state, payload) {
      // - trinary accounts for and edge case with an expired token - called in router/index.js and axios interceptor
      if (payload.modalState) {
        state.modalData.modalState = payload.modalState;
      } else {
        if (!state.token) {
         state.modalData.modalState = 'login'; // no token in localStorage
        } else {
          try {
            const decoded = await jwtDecode(state.token.split(' ')[1]);
            const now = Date.now() / 1000; // seconds
            if (decoded.exp && decoded.exp > now) {
              return ''; // token is not expired, this is probably getting called from missing a partial permission on a page
            } else {
              state.modalData.modalState = 'login' // token is expired
            }
          } catch (err) {
            state.modalData.modalState = 'login'; // invalid token
          }
        }
      }
      state.modalData.modalState = payload.modalState
        ? payload.modalState
        : 'login';
      state.modalData.modalSize = payload.modalSize;
      state.modalData.modalItem = payload.modalItem;
      state.modalData.modalIsActive = true;
    },
    // * Notifications
    SOCKET_notificationsRefreshEmit(state, payload) {
      state.notifications = payload;
    },
  },
  actions: {
    closeModal({ commit }) {
      commit('setCloseModal');
    },
    openModal({ commit }, modalState, modalSize, modalItem) {
      const modalOptions = ['sm', 'lg', 'xl'];
      let test1 = [];
      let sizeOfModal = '';
      if (modalState && modalState.modalSize) {
        sizeOfModal = modalState.modalSize;
      } else if (modalSize) {
        sizeOfModal = modalSize;
      } else {
        sizeOfModal = 'lg';
      }
      if (modalState && modalState.modalItem) {
        test1 = modalState.modalItem;
      }
      modalState = modalState && modalState.modalState ? modalState.modalState : modalState;
      modalSize = sizeOfModal;
      // sizeOfModal = modalState && modalState.modalSize ? modalState.modalSize : modalSize;
      modalItem = test1;
      // if (modalOptions.includes(sizeOfModal)) {
      //   modalSize = sizeOfModal;
      // } else {
      //   modalSize = 'lg';
      // }
      if (sizeOfModal && !modalOptions.includes(sizeOfModal)) {
        throw new Error('Invalid modal size passed as prop');
      }
      const payload = {
        modalState,
        modalSize,
        modalItem,
      };
      commit('setOpenModal', payload);
    },
    fetchModalCurrentVin({ commit }, vin) {
      commit('setCurrentVin', vin);
    },
    fetchModalCurrentStatus({ commit }, status) {
      commit('setCurrentStatus', status)
    },
    fetchModalSearchValue({ commit }, status) {
      commit('setCurrentSearch', status)
    },
    fetchModalCurrentNewItem({ commit }, item) {
      commit('setCurrentNewItem', item)
    },
    fetchModalCurrentNewAvailability({ commit }, availability) {
      commit('setCurrentNewAvailability', availability)
    },
    fetchModalCurrentNewModel({ commit }, truckModel) {
      commit('setCurrentNewModel', truckModel)
    }
  },
};
